import * as React from "react";

import Link from "@mui/material/Link";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { CollectNotification } from "services/types/notifications";

const CollectNotificationComponent = ({
  title,
  description,
  extra
}: CollectNotification) => {
  const { collection_record_id } = extra;
  return (
    <ListItemText
      primary={title}
      secondary={
        <Stack component="span" gap={0.5}>
          <Typography component="span" sx={{ whiteSpace: "pre-line" }}>
            {description}
          </Typography>
          {collection_record_id && (
            <Link
              href={`/collections/view/${collection_record_id}`}
              underline="hover"
            >
              View in Suno Collect
            </Link>
          )}
        </Stack>
      }
    />
  );
};

export default CollectNotificationComponent;
